import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {PartnerBannerAction} from "../partner-banner-action.model";

export class PartnerBannerActionsDgSearchResults extends GenericDgSearchResults {
  public results: PartnerBannerAction[];

  constructor(total: number, results: PartnerBannerAction[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}
